var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`a-avatar-primary a-avatar-side a-avatar-${_vm.avatarClass}`},[(_vm.userImage.length)?_c('img',{key:"avatarImg",attrs:{"src":_vm.userImage}}):_c('img',{key:"defaultImg",attrs:{"src":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }